import { useEffect, useRef } from 'react';
import useAuthStore from '../../../store/rootStore.ts';
import { useDialogStore } from '@/components/dialogs';
import { useWalletSignAuth } from './useWalletSignAuth.ts';

const MAX_AUTO_SIGN_ATTEMPTS = 1;

export const useAuthFlowWatcher = () => {
  const autoSignAttempts = useRef(0);
  const prevStatus = useRef(useAuthStore.getState().status);

  const address = useAuthStore((s) => s.address);
  const status = useAuthStore((s) => s.status);
  const termsAccepted = useAuthStore((s) => s.termsAccepted);
  const authPayloadMessageExists = useAuthStore((s) => !!s.authPayload?.message);

  const { agreeAndSign } = useWalletSignAuth();

  useEffect(() => {
    if (authPayloadMessageExists) {
      if (address && termsAccepted[address]?.mandatory) {
        const currentStatus = useAuthStore.getState().status;
        if (
          autoSignAttempts.current >= MAX_AUTO_SIGN_ATTEMPTS ||
          currentStatus === 'RESTRICTED' ||
          currentStatus === 'AUTHORITY_BLOCKED'
        ) {
          return;
        }
        autoSignAttempts.current += 1;
        agreeAndSign().catch((error) => {
          console.error(error);
        });
      } else {
        const statusForTerms = useAuthStore.getState().status;
        if (statusForTerms !== 'RESTRICTED' && statusForTerms !== 'AUTHORITY_BLOCKED') {
          useDialogStore.getState().openDialog('termsDialog');
        }
      }
    }
  }, [address, authPayloadMessageExists, termsAccepted, agreeAndSign]);

  useEffect(() => {
    autoSignAttempts.current = 0;
  }, [address]);

  useEffect(() => {
    const prev = prevStatus.current;
    if ((prev === 'AUTHENTICATED' || prev === 'AUTHORIZED') && status === 'WALLET_CONNECTED') {
      autoSignAttempts.current = 0;
    }
    prevStatus.current = status;
  }, [status]);
};
